export default __webpack_public_path__ + "static/media/agile.1e7d91c5.png";